/* Epic — sign-up dialog. Behaviour notes live in sections/epic-signup.liquid.

   Storage is a convenience, never a requirement: every read and write is in
   try/catch, and a browser that refuses storage just sees the dialog by the
   ordinary rules — it is never shown twice in one page view either way. */
(() => {
  const dlg = document.querySelector('[data-epic-signup]');
  if (!dlg || typeof dlg.showModal !== 'function') return;

  const KEY = 'epic-signup';
  const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  const write = (v) => { try { localStorage.setItem(KEY, JSON.stringify(Object.assign(read(), v))); } catch (e) {} };
  const sread = (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
  const swrite = (k, v) => { try { v === null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, v); } catch (e) {} };

  const ask = dlg.querySelector('[data-sg-ask]');
  const done = dlg.querySelector('[data-sg-done]');
  const days = Number(dlg.dataset.days || 21);
  let shown = false;

  const open = () => {
    if (shown || dlg.open) return;
    shown = true;
    dlg.showModal();
    dlg.classList.add('is-in');
  };
  const close = () => {
    dlg.classList.remove('is-in');
    dlg.close();
  };

  /* Back from a successful post. Shopify reloads the page with
     ?customer_posted=true; the footer form does the same, so the flag set on
     submit below is what says the post came from THIS form. */
  if (/[?&]customer_posted=true/.test(location.search) && sread('epic-sg-sent')) {
    swrite('epic-sg-sent', null);
    write({ joined: Date.now() });
    ask.hidden = true; done.hidden = false;
    open();
  }

  dlg.querySelector('form')?.addEventListener('submit', () => swrite('epic-sg-sent', '1'));

  dlg.addEventListener('click', (e) => {
    if (e.target.closest('[data-sg-close]') || e.target === dlg) {
      if (!done.hidden) { close(); return; }
      write({ dismissed: Date.now() }); close();
    }
  });
  dlg.addEventListener('cancel', () => { if (done.hidden) write({ dismissed: Date.now() }); });

  if (dlg.hasAttribute('data-preview')) { open(); return; }

  const st = read();
  if (st.joined) return;
  if (st.dismissed && Date.now() - st.dismissed < days * 864e5) return;

  /* Three triggers, first one wins. */
  const delay = Number(dlg.dataset.delay || 30000);
  const scrollAt = Number(dlg.dataset.scroll || 55) / 100;
  const t = setTimeout(open, delay);
  const onScroll = () => {
    const h = document.documentElement.scrollHeight - innerHeight;
    if (h > 0 && scrollY / h >= scrollAt) { open(); off(); }
  };
  const onLeave = (e) => { if (e.clientY <= 0 && !e.relatedTarget) { open(); off(); } };
  const off = () => {
    clearTimeout(t);
    removeEventListener('scroll', onScroll);
    document.removeEventListener('mouseout', onLeave);
  };
  addEventListener('scroll', onScroll, { passive: true });
  if (matchMedia('(pointer: fine)').matches) document.addEventListener('mouseout', onLeave);
})();
